module.exports = __webpack_public_path__ + "static/media/iso-bureau-img.d58b3933.png";